(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
/* G&R premium blog enhancer inline fallback */
(() => {
  const ARTICLE_SELECTOR = 'body.template-article .at-rte';
  const PRODUCT_RE = /\/products\/([a-z0-9-]+)/i;
  const CTA_RE = /(купи|виж продукта|поръчай|добави)/i;
  const PRODUCT_HEADING_RE = /(spf|sun defence|antarctic|еликсир|крем|серум|пяна|почиства|хидратиращ|пребиотич|продукт|масло|рутина)/i;


  // G&R BG: store currency is EUR; block legacy BGN conversion spans on article prices.
  const EUR_ONLY_PRICE_GUARD_ID = 'gr-eur-only-price-guard';
  const ensureEurOnlyPriceGuard = () => {
    if (document.getElementById(EUR_ONLY_PRICE_GUARD_ID)) return;
    const style = document.createElement('style');
    style.id = EUR_ONLY_PRICE_GUARD_ID;
    style.textContent = 'body.template-article .currency-converted{display:none!important;visibility:hidden!important;}';
    document.head.appendChild(style);
  };
  // G&R BG: normalize article widget prices to EUR only; handles stale JS that rendered `20,00 лв.`.
  const EUR_PRICE_NORMALIZER_MARK = 'gr-eur-price-normalizer-20260514';
  const ARTICLE_PRICE_SELECTOR = '.gr-routine-rail__price, .gr-product-rec__price, .grs-price';
  const normalizeLegacyBgnPriceText = (value) => {
    const text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return text;
    const withoutConverted = text.replace(/\s*\(\s*\d+(?:[,.]\d{1,2})?\s*лв\.?\s*\)\s*/gi, '').trim();
    if (withoutConverted.includes('€')) return withoutConverted;
    const match = withoutConverted.match(/^(\d+(?:[,.]\d{1,2})?)\s*лв\.?$/i) || withoutConverted.match(/(\d+(?:[,.]\d{1,2})?)\s*лв\.?/i);
    if (!match) return withoutConverted;
    let amount = match[1].replace('.', ',');
    if (!amount.includes(',')) amount += ',00';
    return `€${amount}`;
  };
  const stripLegacyConvertedCurrency = (root = document) => {
    root.querySelectorAll('.gr-routine-rail__price .currency-converted, .gr-product-rec__price .currency-converted, .grs-price .currency-converted').forEach((node) => node.remove());
    const nodes = [];
    if (root.matches && root.matches(ARTICLE_PRICE_SELECTOR)) nodes.push(root);
    root.querySelectorAll(ARTICLE_PRICE_SELECTOR).forEach((node) => nodes.push(node));
    nodes.forEach((node) => {
      const before = String(node.textContent || '').replace(/\s+/g, ' ').trim();
      const after = normalizeLegacyBgnPriceText(before);
      if (after && after !== before) {
        node.textContent = after;
        node.setAttribute('data-gr-eur-normalized', EUR_PRICE_NORMALIZER_MARK);
      }
    });
  };
  const observeLegacyCurrencyConversion = () => {
    ensureEurOnlyPriceGuard();
    stripLegacyConvertedCurrency();
    if (window.__grEurOnlyPriceGuard) return;
    window.__grEurOnlyPriceGuard = true;
    const observer = new MutationObserver(() => stripLegacyConvertedCurrency());
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(stripLegacyConvertedCurrency, 250);
    window.setTimeout(stripLegacyConvertedCurrency, 1000);
    window.setTimeout(stripLegacyConvertedCurrency, 2500);
  };

  const normalizeUrl = (href) => {
    if (!href) return '';
    try { return new URL(href, window.location.origin).pathname; }
    catch (_) { return href; }
  };

  const productHandleFromHref = (href) => {
    const path = normalizeUrl(href);
    const match = path.match(PRODUCT_RE);
    return match ? match[1].replace(/[^a-z0-9-].*$/i, '') : '';
  };

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    return `€${amount.toFixed(2).replace('.', ',')}`;
  };

  const fetchProduct = async (handle) => {
    const response = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Product fetch failed: ${handle}`);
    return response.json();
  };

  const firstAvailableVariant = (product) => {
    return (product.variants || []).find((variant) => variant.available) || (product.variants || [])[0];
  };

  const productImage = (product) => {
    let src = product.featured_image || '';
    if (src && src.startsWith('//')) src = `${window.location.protocol}${src}`;
    return src;
  };

  const fillCommerce = (target, product, handle, mode = 'full') => {
    if (!target || target.dataset.ready === 'true') return;
    const variant = firstAvailableVariant(product);
    const available = Boolean(variant && variant.available);
    const url = `/products/${handle}`;
    const price = formatMoney((variant && variant.price) || product.price);
    const image = productImage(product);

    if (mode === 'mini') {
      target.innerHTML = `
        <a class="gr-routine-rail__image" href="${url}" aria-label="${product.title}">
          ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}
        </a>
        <div class="gr-routine-rail__copy">
          <a class="gr-routine-rail__name" href="${url}">${product.title}</a>
          <div class="gr-routine-rail__price" data-currency-converted="true">${price}</div>
          ${available && variant ? `<form method="post" action="/cart/add" class="gr-routine-rail__form"><input type="hidden" name="id" value="${variant.id}"><button type="submit">Добави</button></form>` : `<span class="gr-routine-rail__soldout">Изчерпан</span>`}
        </div>`;
      target.dataset.ready = 'true';
      return;
    }

    target.innerHTML = `
      <div class="gr-product-rec__commerce-row">
        <span class="gr-product-rec__price" data-currency-converted="true">${price}</span>
        <span class="gr-product-rec__status">${available ? 'Налично' : 'Изчерпан'}</span>
      </div>
      <div class="gr-product-rec__actions">
        ${available && variant ? `<form method="post" action="/cart/add" class="gr-product-rec__form"><input type="hidden" name="id" value="${variant.id}"><button type="submit" class="gr-product-rec__button">Добави в количката</button></form>` : `<button type="button" class="gr-product-rec__button" disabled>Изчерпан</button>`}
        <a class="gr-product-rec__secondary" href="${url}">Виж продукта</a>
      </div>`;
    target.dataset.ready = 'true';
  };

  const getArticleRoot = (article) => article.querySelector(':scope > .gr-blog') || article;

  const linkHandle = (link) => productHandleFromHref(link && link.getAttribute('href'));

  const hasProductImageLink = (node) => Boolean(node && node.querySelector && node.querySelector('a[href*="/products/"] img'));

  const collectBlockNodes = (heading) => {
    const nodes = [];
    let node = heading.nextElementSibling;
    while (node) {
      if (node.matches('hr')) break;
      if (node.matches('h2')) break;
      if (heading.matches('h3') && node.matches('h3')) break;
      nodes.push(node);
      node = node.nextElementSibling;
    }
    return nodes;
  };

  const isAlreadyEnhanced = (node) => Boolean(node && node.closest && node.closest('.gr-product-rec, .gr-callout, .gr-product-card, .gr-routine-rail'));

  const enhanceProductSections = (article) => {
    const root = getArticleRoot(article);
    if (!root || root.dataset.productSectionsEnhanced === 'true') return;

    const headings = Array.from(root.querySelectorAll(':scope > h2, :scope > h3'));
    headings.forEach((heading) => {
      if (!heading.isConnected || isAlreadyEnhanced(heading)) return;

      const nodes = collectBlockNodes(heading);
      const links = nodes.flatMap((node) => Array.from(node.querySelectorAll ? node.querySelectorAll('a[href*="/products/"]') : []));
      const handles = [...new Set(links.map(linkHandle).filter(Boolean))];
      if (handles.length !== 1) return;

      const firstNode = nodes[0];
      const imageNode = nodes.find(hasProductImageLink);
      const hasExplicitCta = links.some((link) => CTA_RE.test(link.textContent || ''));
      const headingLooksProduct = PRODUCT_HEADING_RE.test(heading.textContent || '');
      const firstNodeIsProductImage = hasProductImageLink(firstNode);
      if (!firstNodeIsProductImage && !(hasExplicitCta && headingLooksProduct)) return;

      const handle = handles[0];
      const card = document.createElement('section');
      card.className = 'gr-product-rec';
      card.dataset.productHandle = handle;

      const media = document.createElement('div');
      media.className = 'gr-product-rec__media';
      const body = document.createElement('div');
      body.className = 'gr-product-rec__body';
      const commerce = document.createElement('div');
      commerce.className = 'gr-product-rec__commerce';
      commerce.innerHTML = '<span class="gr-product-rec__loading">Зареждане на продукта…</span>';

      const badge = document.createElement('div');
      badge.className = 'gr-product-rec__badge';
      badge.textContent = 'Препоръчана грижа';

      heading.parentNode.insertBefore(card, heading);
      card.appendChild(media);
      card.appendChild(body);
      body.appendChild(badge);
      body.appendChild(heading);

      nodes.forEach((node) => {
        if (!node.isConnected) return;
        if (node === imageNode) {
          media.appendChild(node);
          return;
        }
        if (CTA_RE.test(node.textContent || '') && node.querySelector && node.querySelector('a[href*="/products/"]')) {
          node.classList.add('gr-product-rec__legacy-cta');
        }
        body.appendChild(node);
      });
      body.appendChild(commerce);

      fetchProduct(handle)
        .then((product) => fillCommerce(commerce, product, handle, 'full'))
        .catch(() => {
          commerce.innerHTML = `<a class="gr-product-rec__button" href="/products/${handle}">Виж продукта</a>`;
        });
    });

    root.dataset.productSectionsEnhanced = 'true';
  };

  const enhanceExistingProductCallouts = (article) => {
    const root = getArticleRoot(article);
    if (!root || root.dataset.productCalloutsEnhanced === 'true') return;

    root.querySelectorAll('.gr-callout, .gr-product-card').forEach((callout) => {
      if (callout.classList.contains('gr-callout--product')) return;
      const handles = [...new Set(Array.from(callout.querySelectorAll('a[href*="/products/"]')).map(linkHandle).filter(Boolean))];
      if (handles.length !== 1) return;

      const handle = handles[0];
      callout.classList.add('gr-callout--product');
      callout.dataset.productHandle = handle;

      const oldCta = callout.querySelector('.gr-pc-btn');
      if (oldCta && oldCta.parentElement) oldCta.parentElement.remove();

      const existingImage = callout.querySelector('a[href*="/products/"] img');
      let imageLink = existingImage ? existingImage.closest('a') : null;
      if (imageLink) {
        imageLink.className = 'gr-callout__image';
        imageLink.href = `/products/${handle}`;
        imageLink.setAttribute('aria-label', 'Виж продукта');
        existingImage.setAttribute('loading', 'lazy');
        callout.insertBefore(imageLink, callout.firstChild);
      } else {
        imageLink = document.createElement('a');
        imageLink.className = 'gr-callout__image';
        imageLink.href = `/products/${handle}`;
        imageLink.setAttribute('aria-label', 'Виж продукта');
        imageLink.innerHTML = '<span class="gr-callout__image-loading">Продукт</span>';
        callout.insertBefore(imageLink, callout.firstChild);
      }

      const commerce = document.createElement('div');
      commerce.className = 'gr-product-rec__commerce gr-callout__commerce';
      commerce.innerHTML = '<span class="gr-product-rec__loading">Зареждане на продукта…</span>';
      callout.appendChild(commerce);

      fetchProduct(handle)
        .then((product) => {
          const image = productImage(product);
          if (image) imageLink.innerHTML = `<img src="${image}" alt="${product.title}" loading="lazy">`;
          fillCommerce(commerce, product, handle, 'full');
        })
        .catch(() => {
          commerce.innerHTML = `<a class="gr-product-rec__button" href="/products/${handle}">Виж продукта</a>`;
        });
    });

    root.dataset.productCalloutsEnhanced = 'true';
  };


  const refreshRenderedCommerce = (article) => {
    const root = getArticleRoot(article);
    if (!root) return;

    root.querySelectorAll('.gr-routine-rail__item[data-product-handle]').forEach((item) => {
      const handle = item.dataset.productHandle;
      if (!handle) return;
      delete item.dataset.ready;
      fetchProduct(handle)
        .then((product) => fillCommerce(item, product, handle, 'mini'))
        .catch(() => {});
    });

    root.querySelectorAll('.gr-product-rec[data-product-handle], .gr-callout--product[data-product-handle]').forEach((card) => {
      const handle = card.dataset.productHandle;
      const commerce = card.querySelector('.gr-product-rec__commerce');
      if (!handle || !commerce) return;
      delete commerce.dataset.ready;
      fetchProduct(handle)
        .then((product) => fillCommerce(commerce, product, handle, 'full'))
        .catch(() => {});
    });
  };

  const extractProductHandles = (article) => {
    const handles = [];
    article.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      const handle = linkHandle(link);
      if (handle && !handles.includes(handle)) handles.push(handle);
    });
    return handles.slice(0, 4);
  };

  const insertionPointForRail = (root) => {
    const children = Array.from(root.children).filter((node) => node.tagName !== 'STYLE');
    const firstDivider = children.find((node) => node.matches && node.matches('hr'));
    if (firstDivider) return firstDivider;
    return children.find((node, index) => index >= 2 && ['P', 'FIGURE', 'IMG'].includes(node.tagName)) || children[2] || null;
  };

  const addRoutineRail = (article) => {
    const root = getArticleRoot(article);
    if (!root || root.querySelector('.gr-routine-rail')) return;
    const handles = extractProductHandles(root);
    if (handles.length < 2) return;

    const rail = document.createElement('aside');
    rail.className = 'gr-routine-rail';
    rail.setAttribute('aria-label', 'Препоръчана рутина от статията');
    rail.innerHTML = `
      <div class="gr-routine-rail__header">
        <span>Подбрано според статията</span>
        <h3>Препоръчана рутина</h3>
        <p>Продуктите от тази статия — събрани на едно място, без да прекъсват четенето.</p>
      </div>
      <div class="gr-routine-rail__items"></div>`;

    const items = rail.querySelector('.gr-routine-rail__items');
    handles.forEach((handle) => {
      const item = document.createElement('div');
      item.className = 'gr-routine-rail__item';
      item.dataset.productHandle = handle;
      item.innerHTML = '<span class="gr-routine-rail__loading">Зареждане…</span>';
      items.appendChild(item);
      fetchProduct(handle)
        .then((product) => fillCommerce(item, product, handle, 'mini'))
        .catch(() => { item.innerHTML = `<a href="/products/${handle}">Виж продукта</a>`; });
    });

    const point = insertionPointForRail(root);
    if (point && point.parentNode) {
      point.parentNode.insertBefore(rail, point.nextSibling);
    } else {
      root.insertBefore(rail, root.firstChild);
    }
  };

  const init = () => {
    observeLegacyCurrencyConversion();
    const article = document.querySelector(ARTICLE_SELECTOR);
    if (!article) return;
    article.classList.add('gr-blog-modern');
    enhanceProductSections(article);
    enhanceExistingProductCallouts(article);
    addRoutineRail(article);
    refreshRenderedCommerce(article);
    stripLegacyConvertedCurrency(article);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
